import { render } from "./HeaderMenuProductDetailPage.vue?vue&type=template&id=f5692136&scoped=true&ts=true"
import script from "./HeaderMenuProductDetailPage.vue?vue&type=script&lang=ts"
export * from "./HeaderMenuProductDetailPage.vue?vue&type=script&lang=ts"

import "./HeaderMenuProductDetailPage.vue?vue&type=style&index=0&id=f5692136&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5692136"]])

export default __exports__